module.exports = __webpack_public_path__ + "img/crea-ristorante-logo-scuro.81e6043.svg";